import API from "./api";

// GET ALL BLOGS (UPDATED WITH PAGINATION)
export const getBlogs = async (params = {}) => {
  try {
    const query = new URLSearchParams();
    if (Number.isInteger(params.page) && params.page > 0) {
      query.set("page", String(params.page));
    }
    if (Number.isInteger(params.limit) && params.limit > 0) {
      query.set("limit", String(params.limit));
    }
    if (typeof params.status === "string" && params.status.trim()) {
      query.set("status", params.status.trim().toUpperCase());
    }

    const endpoint = query.toString() ? `/blogs?${query.toString()}` : "/blogs";
    const response = await API.get(endpoint);
   // console.log(response)

    console.log("Blog Response Structure:", response.data);

    return response.data;

  } catch (error) {

    console.error(
      "Error fetching blogs:",
      error.response?.data || error.message
    );

    throw error;

  }
};

 

export const getBlogById = async (blogId) => {
  try {
    const response = await API.get(`/blogs/${blogId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching blog by id:", error.response?.data || error.message);
    throw error;
  }
};

export const getBlogsCount = async () => {
  try {
    const response = await API.get("/blogs/count");
    return response.data;
  } catch (error) {
    console.error("Error fetching blog counts:", error.response?.data || error.message);
    throw error;
  }
};

export const getPublishedBlogsCount = async () => {
  try {
    const response = await API.get("/blogs/published/count");
    return response.data;
  } catch (error) {
    console.error("Error fetching published blog count:", error.response?.data || error.message);
    throw error;
  }
};

export const getDraftBlogsCount = async () => {
  try {
    const response = await API.get("/blogs/drafts/count");
    return response.data;
  } catch (error) {
    console.error("Error fetching draft blog count:", error.response?.data || error.message);
    throw error;
  }
};

export const createBlog = async (blogData) => {
  try {
    const response = await API.post("/blogs/create", blogData);
    return response.data;
  } catch (error) {
    console.error("Error creating blog:", error.response?.data || error.message);
    throw error;
  }
};

export const updateBlog = async (blogId, blogData) => {
  try {
    const response = await API.put(`/blogs/${blogId}/update`, blogData);
    return response.data;
  } catch (error) {
    console.error("Error updating blog:", error.response?.data || error.message);
    throw error;
  }
};

export const deleteBlog = async (blogId) => {
  try {
    const response = await API.delete(`/blogs/${blogId}/delete`);
    return response.data;
  } catch (error) {
    console.error("Error deleting blog:", error.response?.data || error.message);
    throw error;
  }
};

export const toggleBlogStatus = async (blogId) => {
  try {
    const response = await API.patch(`/blogs/${blogId}/toggle-status`);
    return response.data;
  } catch (error) {
    console.error("Error toggling blog status:", error.response?.data || error.message);
    throw error;
  }
};





export const uploadMedia = async (file) => {
  try {
    if (!file) throw new Error("No file selected");

    const { data } = await API.post("/images/get-upload-url", {
      fileName: file.name,
      fileType: file.type,
    });

    const { uploadUrl, fileUrl, key } = data;

    const uploadResponse = await fetch(uploadUrl, {
      method: "PUT",
      headers: {
        "Content-Type": file.type,
      },
      body: file,
    });

    if (!uploadResponse.ok) {
      throw new Error("S3 upload failed");
    }

    const saveResponse = await API.post("/images/save-file", {
      name: file.name,
      url: fileUrl,
      key: key,
      type: file.type.startsWith("video") ? "video" : "image",
    });

    return saveResponse.data;

  } catch (error) {
    console.error("Upload failed:", error.message);
    throw error;
  }
};

export const getImages = async () => {
  try {
    const response = await API.get("/images");
    return response.data;
  } catch (error) {
    console.error("Error fetching images:", error.response?.data || error.message);
    throw error;
  }
};

export const deleteImage = async (imageId) => {
  try {
    const response = await API.delete(`/images/${imageId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting image:", error.response?.data || error.message);
    throw error;
  }
};
 
